module.exports = __webpack_public_path__ + "img/car.986ab990.svg";